/**
 * @packageDocumentation
 * @module f1/is
 */

export interface IsBoolean {
  /**
   * Is a boolean
   *
   * @public
   * @function f1.is.boolean
   * @example
   *
   * ```ts
   * f1.is.boolean(true) => true
   * f1.is.boolean(false) => true
   * f1.is.boolean(1 === 1) => true
   *
   * f1.is.boolean('false') => false
   * ```
   */
  (value: unknown): value is boolean;
}

/**
 * @see IsBoolean
 */
export default (value: unknown): value is boolean => {
  return value === true || value === false || toString.call(value) === '[object Boolean]';
};
